import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProyectoService } from 'src/app/services/proyecto.service';
import { Productos } from 'src/app/models/producto.model';

@Component({
  selector: 'app-details-product',
  templateUrl: './details-product.component.html',
  styleUrls: ['./details-product.component.scss']
})
export class DetailsComponent implements OnInit {

  producto: Productos | undefined;
  imagenes: { [idProducto: string]: string } = {
    '105': 'Boligrafo giratorio.png',
    '106': 'Libreta bordada.png',
    '107': 'Bolsa de algodon.png',
    '108': 'Gorra bordada.png',
    '109': 'Chaleco bordado.png',
    '110': 'Termo 500 ml.png',
    '111': 'Casco de seguridad.png',
    '112': 'Carpete Congress.jpg',
    '113': 'Taza.jpg'
  };

  nombres: { [idProducto: string]: string } = {
    '105': 'Boligrafo giratorio',
    '106': 'Libreta bordada',
    '107': 'Bolsa de algodon',
    '108': 'Gorra bordada',
    '109': 'Chaleco bordado',
    '110': 'Termo 500 ml',
    '111': 'Casco de seguridad',
    '112': 'Carpeta Congress',
    '113': 'Taza'
  };

  constructor(private route: ActivatedRoute, private productService: ProyectoService) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const idProducto = +params['idProducto'] || 0; // Convertir a número
      console.log('ID del producto:', idProducto); // Verifica que el ID se está capturando
      this.loadProductDetails(idProducto);
    });

    // Añade el evento para prevenir la edición manual del campo número
    const cantidadInput = document.getElementById('cantidad') as HTMLInputElement;
    if (cantidadInput) {
      cantidadInput.addEventListener('keydown', (event) => {
        event.preventDefault();
      });
    }
  }

  loadProductDetails(idProducto: number): void {
    this.productService.getAllProducts().subscribe(
      response => {
        if (response.success) {
          this.producto = response.data.find(p => p.idProducto === idProducto);
          console.log('Producto encontrado:', this.producto); // Verifica que el producto se está encontrando
        } else {
          console.error('Error en la respuesta:', response.messages);
        }
      },
      error => {
        console.error('Error al obtener productos:', error);
      }
    );
  }
}
